import dayjs from 'dayjs';
import React from 'react';
import { SvgIcon } from '../../calendar/components/svg-icon';
import { getWeekdays, fillWeeksForGrid, DATE_FORMAT } from '../../calendar/helpers/date-helpers';
export const MiniCalendar = (props) => {
    const { eventData, totalMonths, setMonth, currentMonthIndex, clickedDate, selectedDate, todaysDate, specialFlagLegend } = props;
    const activeMonth = dayjs(eventData.days[0].date);
    const weekdays = getWeekdays();
    const REGULAR_EXPRESSION_FOR_TIME = /\s[AP]M\b/g;
    const toggleDate = (date) => {
        if (date == selectedDate) {
            clickedDate(null);
        }
        else {
            clickedDate(date);
        }
    };
    const dateContent = (day) => {
        return (<>
                <span className="pdp-cal-day-date">{dayjs(day.date).format('D')}</span>
                <div className="pdp-cal-day-times">
                    {day.events.map((event, index) => {
                let flagReference = null;
                if (event.specialFlags && event.specialFlags.length > 0) {
                    const flagAria = event.specialFlags.reduce((prev, next) => { return `${prev}flag_${next.id} `; }, "");
                    flagReference = { "aria-describedby": flagAria };
                }
                return (<span className={`pdp-cal-day-time ${!event.isAvailable ? 'pdp-cal-day-time-unavailable' : ''}`} {...flagReference}>
                                    {event.eventTimeString.replace(REGULAR_EXPRESSION_FOR_TIME, "")}
                                    {!!event.specialFlags &&
                        event.specialFlags.map(flag => (<img className="pdp-cal-flag" src={flag.imgSrc} alt=""/>))}
                                </span>);
            })}
                </div>
            </>);
    };
    return (<>
            {!!eventData &&
            <nav className="mini-cal-container" aria-labelledby="calendar-heading">
                    <h3 className="visually-hidden" id="calendar-heading">{`Calendar dates for ${activeMonth.format('MMM YYYY')}`}</h3>
                    <div className="pdp-cal-month-container">
                        {totalMonths.length > 1 ?
                    <>
                                    <button type="button" className="btn-secondary icon-btn-sm mini-cal-month-arrow" onClick={() => setMonth(currentMonthIndex - 1)} disabled={currentMonthIndex === 0}>
                                        <SvgIcon iconId="arrow-left"/>
                                        <span className="visually-hidden">Prev</span>
                                    </button>
                                    <div className="mini-cal-month-dropdown align-center">
                                        <label className="visually-hidden" htmlFor="month-dropdown">Month</label>
                                        <select name="month" id="month-dropdown" className="pdp-cal-month" onChange={(e) => setMonth(parseInt(e.target.value))}>
                                            {totalMonths.map((month, index) => (<option value={index} selected={month == activeMonth.format(DATE_FORMAT)}>{dayjs(month).format('MMM YYYY')}</option>))}
                                        </select>
                                    </div>
                                    <button type="button" className="btn-secondary icon-btn-sm mini-cal-month-arrow" onClick={() => setMonth(currentMonthIndex + 1)} disabled={currentMonthIndex === totalMonths.length - 1}>
                                        <SvgIcon iconId="arrow-right"/>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </>
                    : <p className="pdp-cal-month">{activeMonth.format('MMM YYYY')}</p>}
                    </div>
                    <ul className="mini-cal-weekdays">
                        {weekdays.map((day, index) => (<li className="mini-cal-weekday h6-style">
                                    {day}
                                </li>))}
                    </ul>
                    <ul className="mini-cal-days pdp-cal-days">
                        {fillWeeksForGrid(eventData.days, true).map((day, index) => {
                    const dateData = dayjs(day.date);
                    const isInMonth = dateData.isSame(activeMonth, 'month');
                    const isInPast = dateData.isBefore(todaysDate);
                    return (<li className={`mini-cal-day pdp-cal-day ${!isInMonth || day.events.length < 1 || isInPast ? 'pdp-cal-day-inactive' : ''}`}>
                                        {day.events.length > 0 ?
                            isInPast ?
                                <span className="pdp-cal-day-info">
                                                    {dateContent(day)}
                                                </span>
                                :
                                    <button type="button" onClick={() => toggleDate(day.date)} className={`pdp-cal-day-btn`} aria-current={selectedDate == day.date}>
                                                    {dateContent(day)}
                                                </button>
                            :
                                isInMonth &&
                                    <span className="pdp-cal-day-date">{dayjs(day.date).format('D')}</span>}
                                    </li>);
                })}
                    </ul>
                </nav>}
            {!!specialFlagLegend &&
            <div className="pdp-cal-legend space-top-sm">
                    {specialFlagLegend.map(flag => (<p className="small" id={`flag_${flag.id}`}>
                                <img className="pdp-cal-flag" src={flag.imgSrc} alt=""/>
                                {flag.description}
                            </p>))}
                </div>}
        </>);
};
